
import Vue from "vue";
import AppProductGroupSelectAutcomplete from "@/components/product-group/ProductGroupSelectAutocomplete.vue";
import AppProductGroupSelectAutocompleteSimple from "@/components/product-group/ProductGroupSelectAutocompleteSimple.vue";
import { Product } from "@/models/base";
import { DossierConfigService, ProductService } from "@/services";

export default Vue.extend({
	data(){
		return{
			groupId: null as null | number,
			simpleMainGroup: "",
			simpleSubGroup: "",
			isSaving: false
		};
	},
	props: {
		value: {
			type: Object as ()=>Product,
			required: true
		},
	},
	computed: {
		useSimpleGroups():boolean {
			return DossierConfigService.getGeneralConfig().UseSimpleGroups;
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async save(){
			if (this.isSaving) return false;
			this.isSaving = true;
			try{
				if (!this.useSimpleGroups){
					await ProductService.setGroup(this.groupId, [this.value.ID]);
				}else{
					await ProductService.setSimpleGroups(this.simpleMainGroup, this.simpleSubGroup, [this.value.ID]);
				}
				this.$emit("refresh");
				this.close();
			}catch(err){

			}
			this.isSaving = false;
		}
	},
	mounted(){
		this.groupId = this.value.GroupID;
	},
	components: {
		AppProductGroupSelectAutcomplete,
		AppProductGroupSelectAutocompleteSimple
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
